/**
 * Import Dependency
 */
import React, { Component } from 'react'
import { Button } from 'antd-mobile'

/**
 * Import Antd Mobile Design
 */

/**
 * Import Container
 */

/**
 * Declare Variable
 */

/**
 * Component
 */
class OptionGroupsButtonComponent extends Component {
    renderSubmitButton = () => {
      const {
        intl,
        isActiveBottomSheetSubmitButton,
      } = this.props

      // Intl
      const _confirmSubmitText = intl.formatMessage(
        { id: 'stepper.confirm_submit' },
      )

      return (
        <Button
          type='primary'
          size='large'
          disabled={!isActiveBottomSheetSubmitButton}
          onClick={this.props.confirmOrder}
        >
          {_confirmSubmitText}
        </Button>
      )
    }

    render () {
      // const {
      // classes,
      // stash,
      // stashByOptionGroups,
      // } = this.props

      return (
        <React.Fragment>
          {this.renderSubmitButton()}
        </React.Fragment>
      )
    }
};

/**
 * Export
 */
export default OptionGroupsButtonComponent



// WEBPACK FOOTER //
// ./src/components/OptionGroupsButtons.js